module.exports = __webpack_public_path__ + "static/media/Eye.1ac3d248.svg";